/**
 * orphan-path lint rule — Firestore paths whose `entityId` doesn't resolve
 * to any entity in the manifest. Almost always a parser bug or a stale
 * paths-registry entry.
 */
import type { AtlasManifest } from '../types.js';

export interface OrphanPathFinding {
  ref: string;
  message: string;
}

export function orphanPath(manifest: AtlasManifest): OrphanPathFinding[] {
  const entityIds = new Set(manifest.entities.map((e) => e.id));
  const findings: OrphanPathFinding[] = [];
  for (const p of manifest.paths) {
    if (!entityIds.has(p.entityId)) {
      findings.push({
        ref: p.path,
        message: `Firestore path ${p.path} references unknown entity "${p.entityId}"`,
      });
    }
  }
  return findings;
}
